import React, { useState, useEffect } from "react";
import firebase from "@firebase/app";
import "@firebase/auth";
import {
  blockUser,
  unblockUser,
  VerifyRetailer,
  ResolveRetailer,
} from "../services/UserService";

import { setFraudsterStatus, fetchFraudList, fetchFraudsterListNames, addFraudster, AddFraudsterNote } from "services/RetailerService";
import "react-datepicker/dist/react-datepicker.css";
import { Card, Table, Container, Col, Row, Button,Dropdown,Tab,Tabs } from "react-bootstrap";
import { Input } from "reactstrap";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "../assets/css/table.css";
import { ConfirmBlockModal } from "../components/Modals/ConfirmBlockModal";
import { FraudHistoryModal } from "../components/Modals/FraudHistoryModal";
import { AddFraudsterModal } from "../components/Modals/AddFraudsterModal";
import { AddFraudsterNoteModal } from "../components/Modals/AddFraudsterNoteModal"

import constants from "../constants";
import { addFraudsterNote } from "services/RetailerService";

function fraudUsersView() {
  const [fraudsters, setFraudsters] = useState(null);
  const [fraudster, setFraudster] = useState(null);
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState(["CASHBACK_FRAUD"]);
  const [listName, setListName] = useState("CASHBACK_FRAUD");
  const [fraudstersLoading, setFraudstersLoading] = useState(false);
  const [showConfirmBlockModal, setShowConfirmBlockModal] = useState(false);
  const [showFraudHistoryModal, setShowFraudHistoryModal] = useState(false);
  const [showAddFraudsterModal, setShowAddFraudsterModal] = useState(false);
  const [showAddFraudsterNoteModal, setShowAddFraudsterNoteModal] = useState(false);

  const handleShowConfirmBlockModal = (fraudster) => {
    setShowConfirmBlockModal(true);
    setFraudster(fraudster);
  };

  const handleCloseConfirmBlockModal = () => {
    setShowConfirmBlockModal(false);
  };

  const handleCloseFraudHistoryModal = () => {
    setShowFraudHistoryModal(false);
  };

  const handleAddFraudsterModalClick = async (phoneNumber, reason, note, list) => {
    setShowAddFraudsterModal(false);
    let success = await addFraudster(phoneNumber, reason, note, list);
    if (success)
      init()
  };

  const handleCloseAddFraudsterModal = () => {
    setShowAddFraudsterModal(false);
  };

  const handleShowFraudsterNoteModal = (fraudster) => {
    setShowAddFraudsterNoteModal(true);
    setFraudster(fraudster);
  };

  const handleAddFraudsterNoteModalClick = async (phoneNumber, note) => {
    setShowAddFraudsterNoteModal(false);
    let success = await addFraudsterNote(phoneNumber, note);
    if (success)
      init()
  };

  const handleCloseAddFraudsterNoteModal = () => {
    setShowAddFraudsterNoteModal(false);
  };

  const handleShowFraudHistoryModal = (fraudster) => {
    setShowFraudHistoryModal(true);
    setFraudster(fraudster);
  };

  const [filters, setFilters] = useState({
    phoneNumber: "",
    new: false,
  });

  function onChange(user) {
    if (!user) {
      window.location.href = "/";
    }
    setLoading(false);
  }

  React.useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(onChange);
    return () => unsubscribe();
  }, []);

  const loadFraudsters = async (listName) => {
    if (!loading) {
      setFraudstersLoading(true);
      const fraudsters = await fetchFraudList(listName);

      if (!fraudsters) {
        alert("error when get fraudsters");
        return;
      }
      setFraudsters(fraudsters);
      setFraudstersLoading(false);
    }
  };

  const init = async () => {
    if (!loading) {
      setFraudstersLoading(true);
      const fraudsters = await fetchFraudList(listName);
      let lst = await fetchFraudsterListNames();
      if (!lst.includes('CASHBACK_FRAUD'))
      {
        lst = ["CASHBACK_FRAUD", ...lst]
      }
      setList([lst]);
      if (!fraudsters) {
        setFraudsters([])
      }
      else
      {
        setFraudsters(fraudsters);
      }
      setFraudstersLoading(false);
    }
  };

  useEffect(init, [loading]);

  if (loading || fraudstersLoading) {
    return (
      <div style={{ flex: 1, textAlign: "center" }}>
        <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }

  const handleSearchFilter = (filterType, value) => {
    let newFilter = {
      ...filters,
      [filterType]: value,
    };
    setFilters(newFilter);
  };

  const handleBlockConfrimClick = async (user, blockHours, blockImei) => {
    setShowConfirmBlockModal(false);
    let status = false;
    if (user.status == "BLOCKED") status = await unblockUser(user.phoneNumber);
    else status = await blockUser(user.phoneNumber, blockHours, blockImei);
    if (status) {
      setFraudster(null);
      loadFraudsters(listName);
    }
  };

  const handleVerifyRetailerAccount = async (retailer) => {
    let status = await VerifyRetailer(retailer.phoneNumber);
    if (status) alert("Retailer account verified successfully");
    loadFraudsters(listName);
  };

  const handleResolveRetailer = async (retailer) => {
    let status = await ResolveRetailer(retailer.phoneNumber);
    if (status) alert("retailer resolved successfully");
    loadFraudsters(listName);
  };

  const showFraudHistoryButton = (fraudster) => {
    if (fraudster.reason.length > 1) {
      return (
        <Button
          Button
          style={{ float: "right", marginLeft: 8 }}
          onClick={() => handleShowFraudHistoryModal(fraudster)}
          variant="success"
        >
          history
        </Button>
      );
    }
  };

  const setStatus = async (uid, status) => {
    let success = await setFraudsterStatus(uid, status, listName)
    if (success)
      loadFraudsters(listName);
  }
  const renderStatus = (uid, currentStatus) => {
    return (
      <Dropdown style={{marginBottom:12}} >
        <Dropdown.Toggle variant="success" id="dropdown-basic">{currentStatus}</Dropdown.Toggle>
        <Dropdown.Menu>
          {
            constants.FraudsterStatus.map((status, index) => {
              return <Dropdown.Item key={index} eventKey={index} >
                        <input key={Math.random()}
                          type="checkbox"
                          checked={currentStatus == status}
                          onChange={(e) => setStatus(uid, status)}
                        />
                        {status}
                    </Dropdown.Item>
            })
          }
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  const ActiveAndBlockButton = (fraudster) => {
    if (fraudster.userStatus == "ACTIVE")
      return (
        <Button
          Button
          style={{ float: "right", marginLeft: 8 }}
          onClick={() => handleShowConfirmBlockModal(fraudster)}
          variant="danger"
        >
          block
        </Button>
      );
    if (fraudster.userStatus == "BLOCKED")
      return (
        <Button
          Button
          style={{ float: "right", marginLeft: 8 }}
          onClick={() => handleShowConfirmBlockModal(fraudster)}
          variant="success"
        >
          unblock
        </Button>
      );
  };

  const VerifyRetailerButton = (fraudster) => {
    if (!fraudster.verified)
      return (
        <Button
          Button
          style={{ float: "right", marginLeft: 8 }}
          onClick={() => handleVerifyRetailerAccount(fraudster)}
          variant="success"
        >
          Verify
        </Button>
      );
  };

  const ResolveRetailerButton = (fraudster) => {
    if (!fraudster.resolve)
      return (
        <Button
          Button
          style={{ float: "right", marginLeft: 8 }}
          onClick={() => handleResolveRetailer(fraudster)}
          variant="success"
        >
          Resolve
        </Button>
      );
  };

  const AddNoteButton = (fraudster) => {
      return (
        <Button
          Button
          style={{ float: "right", marginLeft: 8 }}
          onClick={() => handleShowFraudsterNoteModal(fraudster)}
          variant="success"
        >
          note
        </Button>
      );
  };

  const submitSearch = (name) => {
    let filteredFraudsters = [...fraudsters];
    filteredFraudsters.forEach((fraudster) => {
      if (name.trim().length > 0) {
        fraudster.hide = !fraudster.phoneNumber.toLowerCase().includes(name);
        console.log(fraudster);
      } else {
        fraudster.hide = false;
      }
    });

    setFraudsters(filteredFraudsters);
  };

  const renderTab = () => {
    return <>
    <Row>
      <Col md="12">
        <Card className="card-plain table-plain-bg">
          <Card.Body className="table-full-width table-responsive px-0">
            <Table id="invoice">
              <thead>
                <tr>
                  <th className="border-0">phoneNumber</th>
                  <th className="border-0">last Reason</th>
                  <th className="border-0">date</th>
                  <th className="border-0">status</th>
                  <th className="border-0">verified</th>
                  <th className="border-0">Retailer ?</th>
                  <th className="border-0">Note</th>
                  <th className="border-0">action</th>
                </tr>
              </thead>
              <tbody>
                {fraudsters.map((fraudster, index) => {
                  if (fraudster.hide) return;
                  return (
                    <tr key={index}>
                      <td>{fraudster.phoneNumber}</td>
                      <td>
                        {fraudster.reason[fraudster.reason.length - 1]}
                      </td>
                      <td>
                        {fraudster.date[fraudster.date.length - 1]}
                      </td>
                      <td>{fraudster.userStatus}</td>
                      <td>{fraudster.verified ? "Yes" : "No"}</td>
                      <td>{renderStatus(fraudster.phoneNumber, fraudster.fraudStatus)}</td>
                      <td>{fraudster.note}</td>
                      {
                        <td>
                          {ActiveAndBlockButton(fraudster)}
                          {VerifyRetailerButton(fraudster)}
                          {ResolveRetailerButton(fraudster)}
                          {showFraudHistoryButton(fraudster)}
                          {AddNoteButton(fraudster)}
                        </td>
                      }
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
    </>
  }

  const renderTabs = (tabsList) => {
    let tabs = tabsList.map((tabTitle, index) => {
      return <Tab key={index} eventKey={tabTitle} title={tabTitle}>{renderTab()}</Tab>
    })
    return (
      <Tabs
        id="tabs"
        activeKey={listName}
        onSelect={(listName) => {
          setListName(listName);
          loadFraudsters(listName);
        }}
        className="mb-3"
      >
        {tabs}
      </Tabs>
    );
  }

  if (!fraudsters) {
    console.log("No retailers");
    return <p>No Items to show</p>;
  }

  if (loading || fraudstersLoading) {
    return (
      <div style={{ flex: 1, textAlign: "center" }}>
        <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }
  if (fraudsters) {
    return (
      <Container fluid>
        {fraudster &&
          (<ConfirmBlockModal
            show={showConfirmBlockModal}
            handleClose={handleCloseConfirmBlockModal}
            handleClick={handleBlockConfrimClick}
            user={fraudster}
          />)}
         <FraudHistoryModal
              show={showFraudHistoryModal}
              handleClose={handleCloseFraudHistoryModal}
              user={fraudster}
            />
          <AddFraudsterModal
            show={showAddFraudsterModal}
            handleClose={handleCloseAddFraudsterModal}
            handleClick={handleAddFraudsterModalClick}
            lists={list}
            currentList={listName}
          />
          <AddFraudsterNoteModal
            show={showAddFraudsterNoteModal}
            handleClose={handleCloseAddFraudsterNoteModal}
            handleClick={handleAddFraudsterNoteModalClick}
            phoneNumber={fraudster?.phoneNumber}
          />
        <Row>
          <Col md="12">
            <Card className="card-plain table-plain-bg">
              <Card.Header>
                <Row style={{ alignItems: "flex-end" }}>
                  <Col md="4">
                    <label htmlFor="PhoneNumber">Phone Number</label>
                    <Input
                      value={filters.phoneNumber}
                      onChange={(e) => {
                        handleSearchFilter("phoneNumber", e.target.value);
                        submitSearch(e.target.value.toLowerCase());
                      }}
                    />
                  </Col>
                  <Col md="3">
                    <Button
                      Button
                      onClick={() => setShowAddFraudsterModal(true)}
                      variant="success"
                    >
                      add
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
            </Card>
          </Col>
        </Row>
        {renderTabs(list)}
      </Container>
    );
  }
}

export default fraudUsersView;
